import actionTypes from '../actions/actionTypes'
import overlayTypes from 'helpers/enums/overlayTypes'
import lessonSources from 'helpers/enums/lessonSources'

const defaultState = []

function removeOverlay(state, type) {
	const index = state.findIndex(overlay => overlay.overlayType === type)
	if (index !== -1) {
		return state.filter((item, i) => i !== index)
	} else {
		return state
	}
}

function addOverlay(state, overlayType) {
	return [...state, {
		showIn: 'all',
		overlayType,
	}]
}

function addGoogleSlidesRedirectOverlayOnRetry(state, action) {
	if (!action.isInIframe) {
		const type = overlayTypes.FEATURE_GOOGLE_SLIDES_TRANSITION_OVERLAY
		return addOverlay(state, type)
	}
	return state
}

function addGoogleSlidesRedirectOverlayOnEdit(state, action) {
	if (action.lessonData.sourceInfo.type === lessonSources.GOOGLE_SLIDES && !action.isGoogleSlidesEdit) {
		const type = overlayTypes.FEATURE_GOOGLE_SLIDES_TRANSITION_OVERLAY
		return addOverlay(state, type)
	}

	return state
}

function addGoogleSlidesRedirectOverlayOnUnsavedEdit(state, action) {
	if (action.lessonData.state === 0) {
		return addGoogleSlidesRedirectOverlayOnEdit(state, action)
	}

	return state
}

function addInteractiveVideoUploadOverlay(state) {
	const type = overlayTypes.FEATURE_INTERACTIVE_VIDEO_UPLOADING_OVERLAY
	return addOverlay(state, type)
}

const overlayReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.GOOGLE_SLIDES_CREATE_AUTHORIZE_SUCCESS:
			return addGoogleSlidesRedirectOverlayOnRetry(state, action)
		case actionTypes.MY_LIBRARY_EDIT_LESSON:
			return addGoogleSlidesRedirectOverlayOnUnsavedEdit(state, action)
		case actionTypes.MY_LIBRARY_EDIT_LESSON_INIT:
			return addGoogleSlidesRedirectOverlayOnEdit(state, action)
		case actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_FAILED:
		case actionTypes.MY_LIBRARY_EDIT_LESSON_FAILED:
			return removeOverlay(state, overlayTypes.FEATURE_GOOGLE_SLIDES_TRANSITION_OVERLAY)
		case actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_PICKED:
			return addInteractiveVideoUploadOverlay(state)
		case actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_STATUS_SUCCESS:
		case actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_STATUS_FAILED:
		case actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_FAILED:
		case actionTypes.INTERACTIVE_VIDEO_UPLOAD_VIDEO_CANCEL:
			return removeOverlay(state, overlayTypes.FEATURE_INTERACTIVE_VIDEO_UPLOADING_OVERLAY)
		default:
			return state
	}
}

export default overlayReducer
